import React from 'react';

const Footer = () => (
  <footer className="border-t border-line py-10 px-6 md:px-10">
    <div className="max-w-[1500px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
      <span className="font-display font-black tracking-[-0.01em] text-lg">DIFERENCIA</span>
      <span className="text-[10px] tracking-[0.14em] uppercase text-muted text-center">
        India · México · Marruecos · Israel · Camboya · Argentina · EE.UU. · Guatemala
      </span>
      <span className="text-[10px] tracking-[0.14em] uppercase text-muted">© 2026 Sebastian Chuffer</span>
    </div>
  </footer>
);

export default Footer;
